import { ChartSelectionCard } from "../Interfaces/chart-selection-card";
import { AreaChartConstants } from "./area-chart-constants";
import { BarChartConstants } from "./bar-chart-constants";
import { BoxPlotSeriesChartConstants } from "./box-plot-series-chart-constants";
import { CombinationChartConstants } from "./combination-chart-constants";
import { DonutChartConstants } from "./donut-chart-constants";
import { FillChartConstants } from "./fill-chart-constants";
import { LineOrTrendChartConstants } from "./line-or-trend-chart-constants";
import { LollipopChartConstants } from "./lollipop-chart-constants";
import { PieChartConstants } from "./pie-chart-constants";
import { PyramidChartConstants } from "./pyramid-chart-constants";
import { ScatterChartConstants } from "./scatter-chart-constants";
import { SpeedometerChartConstants } from "./speedometer-chart-constants";
import { SpiderChartConstants } from "./spider-chart-constants";
import { StackedBarChartConstants } from "./stacked-bar-chart-constants";
import { TableChartConstants } from "./Table-chart-constants";
import { UniqueChart1Constants } from "./unique-chart-constants";
import { UniqueChart2Constants } from "./unique-chart-constants2";
import { VennDiagramChartConstants } from "./venn-diagram-chart-constants";

export class ChartSelectionConstant {
  static barChartTypes: ChartSelectionCard[] = new BarChartConstants().barChartTypes;
  static stackedBarChartTypes: ChartSelectionCard[] = new StackedBarChartConstants().stackedBarChartTypes;
  // static pyramidChartTypes: ChartSelectionCard[] = new PyramidChartConstants().pyramidChartTypes;
  // static donutChartTypes: ChartSelectionCard[] = new DonutChartConstants().donutChartTypes;
  // static fillChartTypes: ChartSelectionCard[] = new FillChartConstants().fillChartTypes;
  static lineOrTrendChartTypes: ChartSelectionCard[] = new LineOrTrendChartConstants().lineOrTrendChartTypes;
  // static vennDiagramChartTypes: ChartSelectionCard[] = new VennDiagramChartConstants().vennDiagramChartTypes;
  static speedometerChartTypes: ChartSelectionCard[] = new SpeedometerChartConstants().speedometerDiagramChartTypes;
  static pieChartTypes: ChartSelectionCard[] = new PieChartConstants().pieChartTypes;
  static areaChartTypes: ChartSelectionCard[] = new AreaChartConstants().areaChartTypes;
  static scatterChartTypes: ChartSelectionCard[] = new ScatterChartConstants().scatterChartTypes;
  static spiderChartTypes: ChartSelectionCard[] = new SpiderChartConstants().spiderChartTypes;
  static uniqueChartTypes1: ChartSelectionCard[] = new UniqueChart1Constants().uniqueChartTypes;
  static uniqueChartTypes2: ChartSelectionCard[] = new UniqueChart2Constants().uniqueChartTypes;
  static lollipopChartTypes: ChartSelectionCard[] = new LollipopChartConstants().lollipopChartTypes;
  static TableChartTypes: ChartSelectionCard[] = new TableChartConstants().TableChartTypes;
  // static combinationChartTypes: ChartSelectionCard[] = new CombinationChartConstants().combinationChartTypes;
  // static boxPlotSeriesChartTypes: ChartSelectionCard[] = new BoxPlotSeriesChartConstants().boxPlotSeriesChartTypes;
}
